import React, {useState} from "react";
import EstacionamientoHeader from "./EstacionamientoHeader";
import "bootstrap/dist/css/bootstrap.min.css";
import EstacionamientoService from "../../services/EstacionamientoService";
import { useNavigate, NavLink, Navigate } from "react-router-dom";
import { Spinner } from "reactstrap";
import EstacionamientoSmallHeader from "./EstacionamientoSmallHeader";
import LogServices from "../../services/LogServices";



const EstacionamientoLugar = () => {
    const navigate = useNavigate();
    const [lugar, setLugar] = useState({lugar: ""});
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading ] = useState(false);

    const changeHandler = (e) => {
        const { name, value } = e.target;
        setLugar({
          ...lugar,
          [name]: value,
        });
      };

      const hideFooter = () => {
        document.getElementsByTagName("footer")[0].style.visibility='hidden'
      }

      const showFooter = () => {
        document.getElementsByTagName("footer")[0].style.visibility='visible'
      }

      const continueHandler = () => {
        localStorage.setItem("estacionamiento_lugar", lugar.lugar);
        EstacionamientoService.obtenerSensorPorCodigo(lugar.lugar)
        .then((resp)=>{ 
            
                var internalDeviceId = resp.data.extra.sensor.internalDeviceId;
                localStorage.setItem("estacionamiento_internalId", internalDeviceId);
                //EstacionamientoService.cambiarEstadoSensorOcupado(internalDeviceId, true)
                //    .then((respOcupar)=>{
                //        console.log(respOcupar);
                        EstacionamientoService.iniciarEstacionamiento( localStorage.getItem("estacionamiento_celular"),
                        localStorage.getItem("estacionamiento_patente"), localStorage.getItem("estacionamiento_token"), internalDeviceId)
                        .then((respIniciar) => {
                            if (respIniciar.data.errorCode == "6"){
                                setLoading(false);
                                localStorage.setItem("estado_estacionamiento", "1")
                                localStorage.setItem("estacionamiento_horaini", respIniciar.data.extra.hora);
                                navigate("/estacionamientoInicio");
                            }
                            else {
                                EstacionamientoService.cambiarEstadoSensorOcupado(internalDeviceId, false)
                                .then((resp0)=> console.log(resp0));
                                setErrorMessage(respIniciar.data.messageError);
                                setLoading(false);
                            }
                        })
                        .catch((errorIniciar)=> {
                            setErrorMessage(errorIniciar.data);
                            
                            setLoading(false);
                            LogServices.log("Error Iniciar estacionamiento ",localStorage.getItem("estacionamiento_celular"),errorIniciar.message, errorIniciar);
                        
                        })

                    //})
                    //.catch((errorOcupar)=>{
                    //    setErrorMessage(errorOcupar);
                    //    setLoading(false);
                    //    });
              
        }
        )
        .catch((error)=>{
            setErrorMessage(error.data);
            setLoading(false);
            LogServices.log("Error ocupar sensor para estacionamiento ",localStorage.getItem("estacionamiento_celular"), error.message, error);
        })
        setLoading(true);
        
      }

    return (
        <>
       <div class="container text-center estacionamientoContent" >
       <EstacionamientoSmallHeader texto="" retorno="/estacionamientopatente"/>
       <div class="row">
                <div class="col">
                <img class="imgBackIcon" src="./back-go.svg" onClick={()=>{navigate("/estacionamientopatente")}}/>
                        <img src="./estacionamient-inicio-2.png"  class="imgSubtitleMain" ></img>
                   
                </div>
        </div>
       <div class="row">
            <div class="col">
                <h1>Indica el n&uacute;mero de lugar</h1>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <input type="text" name="lugar" 
                className="inputText" value={lugar.lugar} onChange={changeHandler} onFocus={hideFooter} onBlur={showFooter}></input>
                
            </div>
        </div>
        <div class="row">
                <div class="col">
                    <div className="buttonContainer">
                        <button className="buttonRegularClip" onClick={continueHandler}>Siguiente</button>
                    </div>
                </div>
            </div>
           
        </div>
        <p class="errorText" align="center">{errorMessage}</p>
        {loading ?  <div align="center">
   <Spinner color="primary" align="center"/></div>:<></>}
   
        
        </>

    );
    }
export default EstacionamientoLugar;